// ============================================================
// 基础协议命令
// ============================================================
export const CMD_CH585M = {
  firmware_version: [0xa3],
  read_eeprom: [0xa4],
  write_eeprom: [0xa5],
  reset_device: [0xa7],
  firmware_update: [0xa8, 0xb1],
  read_battery: [0xaa],
  init_default_flash: [0xad],
  keyboard_calibration: [0xb0, 0xb1],
  ATI_calibration: [0xb2, 0xb4],
  SMD_calibration: [0xb3, 0xb5],
  demo_mode: [0xb6, 0xb7],
  enter_admin_mode: [0xb8, 0xde, 0xc2, 0xb1, 0xa0],
  exit_admin_mode: [0xb9],
  get_config: [0xd3],
  set_config: [0xd2],
  add_config: [0xd5],
  delete_config: [0xd0],
  delete_Lighting: [0xd6],
} as const

// 恢复出厂设置可选指令
export const INIT_DEFAULT_FLASH = {
  factory: 0x3d,
  admin: 0x4d,
}

// ============================================================
// 协议通用配置（Report ID / ACK 值等）
// ============================================================
export const PROTOCOL_CONFIG = {
  report_id: 0x06,
  feature_report_id: 0x08,
  busy_ack_value: 0x02, // 0x02 表示设备忙碌，需要重试
  read_ack_value: 0x01, // 0x01 表示读取成功
} as const

// ============================================================
// IAP 升级相关常量
// ============================================================
// 升级命令
export const CMD_IAP_PROM = 0x80
export const CMD_IAP_ERASE = 0x81
export const CMD_IAP_VERIFY = 0x82
export const CMD_IAP_END = 0x83
export const CMD_IAP_FW_INFO = 0x84

// 需要进入 BootLoader 的单区设备 PID 列表
export const SINGLE_PID_LIST: number[] = [0x4822, 0x4823, 0x4a00]
